document.querySelector('.affiliate__apply-button').addEventListener("click", (event) => {
    let formConplete = true;
    Array.prototype.forEach.call(document.querySelectorAll('.affiliate__field-input'), element => { 
        if (element.value == "") formConplete = false; 
    });
    if (formConplete) {
        const formData = {
            name: document.getElementById('name').value,
            organization: document.getElementById('org').value,
            email: document.getElementById('email').value,
            phoneNumber: document.getElementById('phone').value,
            shirt: document.getElementById('shirt').value,
            reason: document.getElementById('reason').value,
        }
        console.log(formData);
        event.preventDefault();
        fetch('https://eok3hl67r8rnh9t.m.pipedream.net', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        }).then(res => {
            console.log(res)
            if (res.status === 200) {
                document.querySelector('.affiliate__success-section').style.display = 'flex';
                document.querySelector('.affiliate__form-section').style.display = 'none';
            } else {
                document.querySelector('.affiliate__errant-message').innerHTML = "Submission failure";
            }
        })
    } else {
        document.querySelector('.affiliate__errant-message').innerHTML = 'Please complete all fields';
    }
});